import { SELECT_MATERIAL, SELECT_EXPRESSION, SELECT_THICKNESS, SELECT_EDGE, SELECT_KITCHEN_ISLAND_SAME_AS_WORKTOP, SELECT_COVER_PANEL } from 'domain/Options/constants';
import { getParameterId } from 'domain/Options/reducers/plan';
import * as parameters from '../planParameters';

function kitchenIslandReducer(state, action) {
  if (!state.getIn(['plan', 'kitchenIslandSameAsWorktop'])) {
    return state;
  }

  let stateToUse = state;
  const paramsToCopy = [];

  // Order matters (because of fall throughs)!
  switch (action.type) {
    case SELECT_KITCHEN_ISLAND_SAME_AS_WORKTOP:
      if (!action.sameAsWorktop) {
        return state;
      }
      // fall through

    case SELECT_MATERIAL:
      paramsToCopy.push([parameters.material, parameters.kitchenIslandMaterial]);
      // fall through

    case SELECT_EXPRESSION:
      paramsToCopy.push([parameters.expression, parameters.kitchenIslandExpression]);
      stateToUse = state.setIn(['plan', 'kitchenIslandExpressionSelections', getParameterId(state, parameters.material)], state.getIn(['plan', parameters.expression, 'value']));
      // fall through

    case SELECT_COVER_PANEL:
      paramsToCopy.push([parameters.coverPanel, parameters.kitchenIslandCoverPanel]);
      stateToUse = state.setIn(['plan', 'kitchenIslandCoverPanelSelections', getParameterId(state, parameters.material)], state.getIn(['plan', parameters.coverPanel, 'value']));
        // fall through

    case SELECT_THICKNESS:
      paramsToCopy.push([parameters.thickness, parameters.kitchenIslandThickness]);
      // fall through

    case SELECT_EDGE:
      paramsToCopy.push([parameters.edge, parameters.kitchenIslandEdge]);
      break;
    default:
      break;
  }

  return paramsToCopy.reduce((tmpState, [from, to]) => {
    return tmpState.setIn(['plan', to], tmpState.getIn(['plan', from]));
  }, stateToUse);
}

export default kitchenIslandReducer;
